import React, {useContext} from 'react';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import Login from "../components/login/Login";
import RouteSecond from "./RouteSecond";
import PrivateRoute from "./PrivateRoute";
import UserContext from "../context/user/UserContext";

const RouteApp = () => {
    const {logged} = useContext(UserContext);

    return(
        <Router>
            <Switch>
                <Route exact path = "/login" component = {Login} />
                <PrivateRoute path = "/" component = {RouteSecond} isAuthenticated ={logged} />
            </Switch>
        </Router>
    )
}

export default RouteApp;